import { Component, OnInit, Input, ViewContainerRef } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeInDown } from 'ng-animate';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ConfirmdialogComponent } from '../../../common/dialog/confirmdialog.component';
import { ApirequestService } from '../../../../services/apirequest/apirequest.service';
import { ApiurlsService } from '../../../../services/api-urls/apiurls.service';
import { Router } from '@angular/router';
import { UtilityService } from '../../../../services/utilities/utilities.services';
import { OrderPipe } from 'ngx-order-pipe';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { FormGroup, FormBuilder } from '@angular/forms';


@Component({
  selector: 'hybse-voucher-list',
  templateUrl: './voucherlist.component.html',
  styleUrls: ['./voucherlist.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ],
})
export class VoucherlistComponent implements OnInit {
  voucherForm: FormGroup;
  showLoader = true;
  voucherList: any = [];
  paginatorList: any = [];
  public paginatorCount: number;
  fadeInDown: any;
  public errorMessage: string;
  listTitle = 'All Vouchers - Redeemed';
  public count: number;
  public limit = 50;
  public offset = 0;
  public filterType: number;
  voucherStatus: any = [];
  public isInit: boolean = false;

  // sorting
  reverse = false;
  order = 'createdat';
  sortedCollection: any[];

  constructor(public dialog: MatDialog,
              public _api: ApirequestService,
              public _urls: ApiurlsService,
              public _utils: UtilityService,
              public router: Router,
              public toastr: ToastsManager, vcr: ViewContainerRef,
              private _fb: FormBuilder,
              private orderPipe: OrderPipe) {
    this.toastr.setRootViewContainerRef(vcr);
  }

  ngOnInit() {
    this.getVoucherList(false);
    this.voucherFormInit();
    this.sortedCollection = this.orderPipe.transform(this.voucherList, this.order);
  }

  voucherFormInit() {
    this.voucherForm = this._fb.group({
      filter: ['']
    });
  }

  getVoucherList(formSubmit) {
    let data = {};
    if (!formSubmit) {
      data = {
        offset: this.offset,
        limit: this.limit,
      };
    } else {
      data = {
        ...this.voucherForm.value,
        offset: 0,
        limit: this.limit,
      };
      this.voucherForm.setValue({filter: ['']});
    }

    this.voucherList = [];
    this._api.fetchApiData(this._urls.voucherRedeemedUrl, data).subscribe(
      (res: any) => {
        const response = res.data;
        const resErr = res.error;
        if (response !== '') {
          this.voucherList = response.redeemedVoucherList;
          this.count = response.count;
        } else {
          this.errorMessage = resErr['errorDescription'];
        }
      },
      error => {
        this.showLoader = false;
      },
      () => {
        this.showLoader = false;
        if (!this.isInit) {
          this.paginatorList = this.voucherList;
          this.paginatorCount = this.count;
          this.isInit = true;
        }
      }
    );
  }

  voucherSubmit() {
    if (this.voucherForm.valid) {
      this.showLoader = true;
      this.getVoucherList(true);
    }
  }

  checkActive(active, index) {
    this.voucherStatus[index] = (active) ? 'Active' : 'Inactive';
    return active;
  }

  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }
    if (value === 'createdat') {
      this.showLoader = true;
      this.reverse ? this.filterType = 1 : this.filterType = 2;
      this.getVoucherList(false);
    }
    this.order = value;
  }

  pagination(e) {
    this.offset = (e.pageIndex * 50);
    this.getVoucherList(false);
  }

  ngOnChanges() {
    this.listTitle = 'Redeemed Voucher List';
  }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/company/voucherlist/voucherlist.component.ts